var render = function render(){var _vm=this,_c=_vm._self._c;return _c('HeaderItem',{staticClass:"headerLogo"},[_c('div',{staticClass:"imgCls"},[_c('img',{attrs:{"src":_vm.logoUrl}}),_c('div',{staticClass:"logoTitle"},[_vm._v(_vm._s(_vm.logoTitle))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }